import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, Table } from 'reactstrap';
import { transform, transformExtent } from 'ol/proj';  // Import projection transformation

import View from 'ol/View'
import { getCenter } from 'ol/extent'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import Map from 'ol/Map'
import { FullScreen, defaults as defaultControls } from 'ol/control.js';
import { TileWMS, XYZ, } from 'ol/source';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Style from 'ol/style/Style';
import { Circle as CircleStyle } from 'ol/style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { fromLonLat } from 'ol/proj';
import Feature from 'ol/Feature';
import { Point, Polygon } from 'ol/geom';
import { bbox as loadingstrategy } from 'ol/loadingstrategy';



function hexToRgba(hex: string, alpha: number) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return `rgba(1, 148, 154, ${alpha})`;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

const MainMap = (props: any) => {
  const mapTargetRef = React.useRef<HTMLDivElement>(null);
  const [modal_center, setmodal_center] = useState(false);
  const [modal_spring, setmodal_spring] = useState(false);
  const [modal_lake, setmodal_lake] = useState(false);
  const [sav29GazarDetail, setSav29GazarDetail] = useState('' as any);
  const [springDetail, setSpringDetail] = useState('' as any);
  const [lakeDetail, setLakeDetail] = useState('' as any);
  const [lakeGeometry, setLakeGeometry] = useState('' as any);
  const [lakeCrs, setLakeCrs] = useState('' as any);


  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  function tog_spring() {
    setmodal_spring(!modal_spring);
    removeBodyCss();
  }


  function tog_lake() {
    setmodal_lake(!modal_lake);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  async function getElevation(lat: number, lon: number) {
    const url = `https://api.open-elevation.com/api/v1/lookup?locations=${lat},${lon}`;
    const response = await fetch(url);
    const data = await response.json();
    return data.results[0].elevation;
  }

  let customWidth = props.customWidth;
  let customHeight = props.customHeight;

  useEffect(() => {


    const imageExtent = [9018917.1074, 4799022.3839, 13473626.3819, 7178965.6965];

    let baseMap = props.baseMap;
    let results = props?.results;
    let customCenter = props?.customCenter;
    let geoJsonResult = results;

    if (typeof results === 'string') {
      try {
        geoJsonResult = JSON.parse(results);
      } catch {
        geoJsonResult = null;
      }
    }

    const hasValidGeometry = Boolean(
      geoJsonResult &&
      typeof geoJsonResult === 'object' &&
      typeof geoJsonResult.type === 'string' &&
      (Array.isArray(geoJsonResult.coordinates) ||
        (geoJsonResult.type === 'FeatureCollection' && Array.isArray(geoJsonResult.features) && geoJsonResult.features.length > 0))
    );

    let tempCenter;

    if (props.type === 'point') {
      tempCenter = [customCenter?.cusCenter?.[0] + 0, customCenter?.cusCenter?.[1]];
    } else {
      tempCenter = [customCenter?.cusCenter?.[0] + 0, customCenter?.cusCenter?.[1] + 0.10];
    }

    var view = new View({
      // center: getCenter(imageExtent),
      center: customCenter === undefined ? getCenter(imageExtent) : fromLonLat(tempCenter),
      zoom: props.zoomChange ? props.zoomChange : 6,
      minZoom: 3,
      maxZoom: 20,
    });

    const baseLayers = {
      osm: new TileLayer({
        source: new OSM(),
        visible: baseMap === 'openstreet'
      }),
      xyz: new TileLayer({
        source: new OSM(),
        visible: baseMap === 'voyager'
      }),
      google: new TileLayer({
        source: new XYZ({
          url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
        }),
        visible: baseMap === 'google'
      }),
      topo: new TileLayer({
        source: new XYZ({
          url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png'
        }),
        visible: baseMap === 'topo'
      })
    };

    const map = new Map({
      controls: defaultControls().extend([new FullScreen()]),
      target: mapTargetRef.current || undefined,
      layers: Object.values(baseLayers),
      view: view,
    })

    // if (!!props?.onPointed) {
    //   map.on('singleclick', async function (evt) {
    //       const [lon, lat] = transform(
    //         evt.coordinate,
    //         'EPSG:3857',
    //         'EPSG:4326'
    //       );
    //       const elevation = await getElevation(lat, lon);
    //       props.onPointed({
    //         longitude: lon,
    //         latitude: lat,
    //         elevation: elevation
    //       })
    //   });
    // }

    if (props?.mainFilter?.sav29Filter === false || props?.mainFilter?.sav29Filter === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "29basin");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.mainFilter.sav29Filter = false;
      }
    } else {
      const SAV_29_GAZAR_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geo.infowater.mn/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:29basin',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      SAV_29_GAZAR_LAYER.set('name', '29basin');
      SAV_29_GAZAR_LAYER.setZIndex(10);
      map.addLayer(SAV_29_GAZAR_LAYER);



      map.on('singleclick', function (evt) {
        var newCord = evt.coordinate;
        const bufferSize = 10;
        const minX = newCord[0] - bufferSize;
        const minY = newCord[1] - bufferSize;
        const maxX = newCord[0] + bufferSize;
        const maxY = newCord[1] + bufferSize;
        const wmsLayer = new TileLayer({
          source: new TileWMS({
            url: 'https://geo.infowater.mn/geoserver/satellite/wms',
            params: {
              'SERVICE': 'WMS',
              'VERSION': '1.1.1',
              'REQUEST': 'GetFeatureInfo',
              'LAYERS': 'satellite:29basin',
              'QUERY_LAYERS': 'satellite:29basin',
              'FORMAT': 'image/png',
              'SRS': 'EPSG:4326',
              'BBOX': `${minX},${minY},${maxX},${maxY}`,
              'FEATURE_COUNT': 5,
              'TILED': true,
            },
            serverType: 'geoserver',
            crossOrigin: 'anonymous',
          }),
        });
        map.addLayer(wmsLayer);
        const viewResolution = map.getView().getResolution();
        if (viewResolution === undefined) {
          console.error('View resolution is undefined.');
          return;
        }
        const source = wmsLayer.getSource();
        if (!source) {
          console.error('WMS source is not available.');
          return;
        }
        const url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          {
            'INFO_FORMAT': 'application/json',
            'FEATURE_COUNT': 5,
          }
        );
        if (url) {
          fetch(url)
            .then(response => response.json())
            .then(data => {
              tog_center();
              setSav29GazarDetail(data.features[0].properties)
            })
            .catch(error => {
              console.error(error);
            });
        }
      });


    }

    if (props?.mainFilter?.arkhangaiFilter === false || props?.mainFilter?.arkhangaiFilter === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "arkhangai_river");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.mainFilter.arkhangaiFilter = false;
      }
    } else {
      const ARKHANGAI_RIVER_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geo.infowater.mn/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:AR_protected_zone1',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
            'TILED': true,
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      ARKHANGAI_RIVER_LAYER.set('name', 'arkhangai_river');
      ARKHANGAI_RIVER_LAYER.setZIndex(20);
      map.addLayer(ARKHANGAI_RIVER_LAYER);
    }

    if (props?.surfaceWaterFilter?.riverFilter === false || props?.surfaceWaterFilter?.riverFilter === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "mongolia_river");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.surfaceWaterFilter.riverFilter = false;
      }
    } else {
      const MONGOLIA_RIVER_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geo.infowater.mn/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:River',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
            'TILED': true,
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      MONGOLIA_RIVER_LAYER.set('name', 'mongolia_river');
      MONGOLIA_RIVER_LAYER.setZIndex(30);

      map.addLayer(MONGOLIA_RIVER_LAYER);

    }

    if (props?.surfaceWaterFilter?.springFilter === false || props?.surfaceWaterFilter?.springFilter === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "mongolia_spring");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.surfaceWaterFilter.springFilter = false;
      }
    } else {
      const MONGOLIA_SPRING_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geo.infowater.mn/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:Spring',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
            'TILED': true,
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      MONGOLIA_SPRING_LAYER.set('name', 'mongolia_spring');
      MONGOLIA_SPRING_LAYER.setZIndex(40);
      map.addLayer(MONGOLIA_SPRING_LAYER);



      map.on('singleclick', function (evt) {
        var newCord = evt.coordinate;
        const bufferSize = 10;
        const minX = newCord[0] - bufferSize;
        const minY = newCord[1] - bufferSize;
        const maxX = newCord[0] + bufferSize;
        const maxY = newCord[1] + bufferSize;
        const wmsLayer = new TileLayer({
          source: new TileWMS({
            url: 'https://geo.infowater.mn/geoserver/satellite/wms',
            params: {
              'SERVICE': 'WMS',
              'VERSION': '1.1.1',
              'REQUEST': 'GetFeatureInfo',
              'LAYERS': 'satellite:Spring',
              'QUERY_LAYERS': 'satellite:Spring',
              'FORMAT': 'image/png',
              'SRS': 'EPSG:4326',
              'STYLES': 'spring_sld_last',
              'BBOX': `${minX},${minY},${maxX},${maxY}`,
              'FEATURE_COUNT': 5,
              'TILED': true,
              'CQL_FILTER': `INTERSECTS(the_geom, POINT(${newCord[0]} ${newCord[1]}))`,
            },
            serverType: 'geoserver',
            crossOrigin: 'anonymous',
          }),
        });
        map.addLayer(wmsLayer);
        const viewResolution = map.getView().getResolution();
        if (viewResolution === undefined) {
          console.error('View resolution is undefined.');
          return;
        }
        const source = wmsLayer.getSource();
        if (!source) {
          console.error('WMS source is not available.');
          return;
        }
        const url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          {
            'INFO_FORMAT': 'application/json',
            'FEATURE_COUNT': 5,
          }
        );
        if (url) {
          fetch(url)
            .then(response => response.json())
            .then(data => {
              setSpringDetail(data.features[0].properties);
              tog_spring();
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    }

    if (props?.lakeFilter?.lakeBoolean === false || props?.lakeFilter?.lakeBoolean === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "mongolia_lake");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.lakeFilter.lakeBoolean = false;
      }
    } else {
      const MONGOLIA_LAKE_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geo.infowater.mn/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:nuur',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
            'TILED': true,
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      MONGOLIA_LAKE_LAYER.set('name', 'mongolia_lake');
      MONGOLIA_LAKE_LAYER.setZIndex(30);
      map.addLayer(MONGOLIA_LAKE_LAYER);
      map.on('singleclick', function (evt) {
        const newCord = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326')
        const wfsSource = new VectorSource({
          format: new GeoJSON(),
          url: function (extent) {
            return 'https://geo.infowater.mn/geoserver/satellite/ows?' +
              'service=WFS&version=1.1.0&request=GetFeature&typename=satellite:nuur&' +
              'outputFormat=application/json&srsname=EPSG:4326&' +
              'bbox=' + extent.join(',') + ',EPSG:4326';
          },
          strategy: loadingstrategy,
        });
        const vectorLayer = new VectorLayer({
          source: wfsSource,
        });
        map.addLayer(vectorLayer);
        const viewResolution = map.getView().getResolution();
        if (viewResolution === undefined) {
          console.error('View resolution is undefined.');
          return;
        }
        const source = vectorLayer.getSource();
        if (!source) {
          console.error('WMS source is not available.');
          return;
        }
        const bufferSize = 0.01; // Жижиг buffer (ойролцоогоор 1 км)
        const bbox = [
          (newCord[0] - bufferSize).toFixed(6),
          (newCord[1] - bufferSize).toFixed(6),
          (newCord[0] + bufferSize).toFixed(6),
          (newCord[1] + bufferSize).toFixed(6)
        ].join(',');
        const url = 'https://geo.infowater.mn/geoserver/satellite/ows?' +
          'service=WFS&version=1.0.0&request=GetFeature&typeName=satellite%3Anuur&' +
          'maxFeatures=50&outputFormat=application%2Fjson&srsname=EPSG:4326&' +
          'bbox=' + bbox;
        if (url) {
          fetch(url)
            .then(response => response.json())
            .then(data => {
              tog_lake();
              console.log('data', data)
              setLakeDetail(data.features[0].properties)
              props?.setLakeGeometry(data.features[0].geometry)
              props?.setLakeId(data.features[0].id)

              if (data.features[0]) {
                props?.onLakeSelected(data.features[0]);

                const [lon, lat] = transform(
                  evt.coordinate,
                  'EPSG:3857',
                  'EPSG:4326'
                );

                getElevation(lat, lon)
                  .then(elevation => {
                    props.onPointed({
                      longitude: lon,
                      latitude: lat,
                      elevation
                    });
                  })
                  .catch(err => {
                    console.log(err);
                    props.onPointed({
                      longitude: lon,
                      latitude: lat,
                      elevation: 0
                    });
                  });
              }

            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    }

    if (props?.protectionZoneFilter?.specialZoneFilter === false || props?.protectionZoneFilter === undefined) {
      const layerToRemove = map
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "mongolia_protection_zone");
      if (layerToRemove) {
        map.removeLayer(layerToRemove);
        props.protectionZoneFilter.specialZoneFilter === true && (props.protectionZoneFilter.specialZoneFilter = false);
        props.protectionZoneFilter.normalZoneFilter === true && (props.protectionZoneFilter.normalZoneFilter = false);
      }
    } else {
      const MONGOLIA_PORTECTION_LAYER = new TileLayer({
        source: new TileWMS({
          url: 'https://geoserver.erkhet-innovation.com/geoserver/satellite/wms',
          params: {
            'SERVICE': 'WMS',
            'VERSION': '1.1.0',
            'REQUEST': 'GetMap',
            'LAYERS': 'satellite:water_portection_zone',
            'FORMAT': 'image/png',
            'SRS': 'EPSG:4326',
            'STYLES': 'water_portection_zone_style',
            'TILED': true,
            'COL': props?.protectionZoneFilter?.colQuery
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
        }),
      });
      MONGOLIA_PORTECTION_LAYER.set('name', 'mongolia_protection_zone');
      MONGOLIA_PORTECTION_LAYER.setZIndex(50);
      map.addLayer(MONGOLIA_PORTECTION_LAYER);
    }




    if (hasValidGeometry && props?.type !== 'point') {
      const format = new GeoJSON();
      const vectorSources = new VectorSource();
      const features: any = format.readFeatures(geoJsonResult, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      })

      for (var i = 0; i < features?.length; i++) {
        vectorSources.addFeature(features[i]);
      }

      const vectorLayer = new VectorLayer({
        source: vectorSources,
        // FeatureCollection-ийн feature бүр өөрийн `color` property-тэй бол түүгээр будна
        style: (feature) => {
          const color = feature.get('color') || '#01949A';
          return new Style({
            stroke: new Stroke({ color, width: 2 }),
            fill: new Fill({ color: hexToRgba(color, 0.25) }),
          });
        }
      })
      map.addLayer(vectorLayer);
      if (features.length > 0) {
        view.fit(vectorSources.getExtent(), {
          padding: [40, 40, 40, 40],
          maxZoom: 14,
          duration: 250,
        });
      }
    } else if (
      props?.type === 'point' &&
      hasValidGeometry &&
      Number.isFinite(Number(geoJsonResult?.coordinates?.[0])) &&
      Number.isFinite(Number(geoJsonResult?.coordinates?.[1]))
    ) {
      const pointLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              geometry: new Point(fromLonLat([geoJsonResult.coordinates[0], geoJsonResult.coordinates[1]])),
            }),
          ],
        }),
        style: new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({ color: '#90d9ef ' }),
            stroke: new Stroke({ color: '#4275be', width: 4 }),
          }),
        }),
      });
      map.addLayer(pointLayer);
    }

    return () => {
      map.setTarget(undefined)
    }
  }, [props?.surfaceWaterFilter?.springFilter, props?.surfaceWaterFilter?.riverFilter, props?.mainFilter?.sav29Filter, props?.mainFilter?.arkhangaiFilter, props?.baseMap, props?.results, props?.customCenter, props?.type, props?.protectionZoneFilter?.colQuery, props?.lakeFilter])

  return (
    <>
      <style>
        {`
            .modal - backdrop.show{
              opacity: 0;
            }
            `}
      </style>

      <div ref={mapTargetRef} style={{ width: customWidth ? customWidth : '100%', height: customHeight ? customHeight : '800px' }} />

      {/* springDetail */}
      <Modal
        isOpen={modal_lake}
        toggle={() => {
          tog_lake();
        }}
        centered
      >
        <ModalHeader toggle={() => {
          tog_lake();
        }}>
          <div className="modal-title mt-0 h5 fw-semibold">Нэмэлт мэдээлэл</div>
        </ModalHeader>
        <div className="modal-body">
          <div className="table-responsive">
            <Table className="table table-striped mb-0">
              <tbody>
                <tr>
                  <th scope="row">Нуур (тойром)-ын нэр</th>
                  <td className='fs-6 text-start'>{lakeDetail.namemon}</td>
                </tr>
                <tr>
                  <th scope="row">Нуур (тойром)-ын ёроолын хурдас чулуулгийн нэр</th>
                  <td className='fs-6 text-start'>{lakeDetail.classmon}</td>
                </tr>
                <tr>
                  <th scope="row"> Урсац </th>
                  <td className='fs-6 text-start'>{lakeDetail.typemon}</td>
                </tr>

              </tbody>
            </Table>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modal_spring}
        toggle={() => {
          tog_spring();
        }}
        centered
      >
        <ModalHeader toggle={() => {
          tog_spring();
        }}>
          <div className="modal-title mt-0 h5 fw-semibold">Нэмэлт мэдээлэл</div>
        </ModalHeader>
        <div className="modal-body">
          <div className="table-responsive">
            <Table className="table table-striped mb-0">
              <tbody>
                <tr>
                  <th scope="row">Булаг нэр</th>
                  <td className='fs-6 text-start'>
                    {/* {springDetail} */}
                    Булгын нэр static
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center();
        }}
        centered
      >
        <ModalHeader toggle={() => {
          tog_center();
        }}>
          <div className="modal-title mt-0 h5 fw-semibold">Нэмэлт мэдээлэл</div>
        </ModalHeader>
        <div className="modal-body">
          <div className="table-responsive">
            <Table className="table table-striped mb-0">
              <tbody>
                <tr>
                  <th scope="row">Сав газар</th>
                  <td className='fs-6 text-start'>{sav29GazarDetail.NewBasinNa}</td>
                </tr>
                <tr>
                  <th scope="row">Нийт талбайн хэмжээ</th>
                  <td className='fs-6 text-start'>{sav29GazarDetail.AREA_KM2} км<sup>2</sup></td>
                </tr>
                <tr>
                  <th scope="row"> Дүрс урт </th>
                  <td className='fs-6 text-start'>{sav29GazarDetail.Shape_Leng} км<sup>2</sup></td>
                </tr>
                <tr>
                  <th scope="row"> Дүрс хэмжээ </th>
                  <td className='fs-6 text-start'>{sav29GazarDetail.Shape_Area} км<sup>2</sup></td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default MainMap;
